import type { LoginRequest, LoginResponse } from 'dto';
import { api } from 'api/v1/api';
import { session } from 'api/v1/paths';

export const postLogin = async (payload: LoginRequest): Promise<LoginResponse> => {
  const response = await api.post<LoginResponse>(session.login, payload, {
    withCredentials: true,
  });
  return response.data;
};

export const postLogout = async (): Promise<void> => {
  const response = await api.post(session.logout, null, {
    withCredentials: true,
  });
  return response.data;
};
